import { render, staticRenderFns } from "./PointOfSales.vue?vue&type=template&id=78f240a2&scoped=true&"
import script from "./PointOfSales.vue?vue&type=script&lang=js&"
export * from "./PointOfSales.vue?vue&type=script&lang=js&"
import style0 from "./PointOfSales.vue?vue&type=style&index=0&id=78f240a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f240a2",
  null
  
)

export default component.exports